import { ChangeDetectionStrategy, Component, Inject, signal } from '@angular/core';
import { TableCellData } from '../../../../osp-ui/components/data/table/contract/table-cell-data.contract';
import { TableCellBase } from '../../../../osp-ui/components/data/table/directives/table-cell-base.directive';
import { TABLE_CELL_DATA } from '../../../../osp-ui/components/data/table/table.constant';

@Component({
  selector: 'osp-table-cell-html',
  standalone: true,
  templateUrl: './table-cell-html.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellHtmlComponent extends TableCellBase<string> {
  content$ = signal('');

  constructor(@Inject(TABLE_CELL_DATA) data: TableCellData) {
    super(data);
  }
}
